
import { useDashboardData } from "@/hooks/manager/useDashboardData";
import { NewsFeed } from "@/components/manager/NewsFeed";
import { useLanguage } from "@/contexts/LanguageContext";

const ManagerDashboard = () => {
  const { loading, memberData, news } = useDashboardData();
  const { t } = useLanguage();

  if (loading) {
    return (
      <div 
        className="min-h-screen bg-white flex items-center justify-center pb-20 md:pb-0"
        style={{ fontFamily: 'Newsreader, "Noto Sans", sans-serif' }}
      >
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#1B365D]"></div>
      </div>
    );
  }

  if (!memberData?.organization) {
    return (
      <div 
        className="min-h-screen bg-white flex items-center justify-center pb-20 md:pb-0"
        style={{ fontFamily: 'Newsreader, "Noto Sans", sans-serif' }}
      >
        <div className="text-lg text-[#2F80ED]">Error loading dashboard</div>
      </div>
    );
  }

  return (
    <div 
      className="relative flex size-full min-h-screen flex-col bg-white group/design-root overflow-x-hidden pb-20 md:pb-0"
      style={{ fontFamily: 'Newsreader, "Noto Sans", sans-serif' }}
    >
      <div className="layout-container flex h-full grow flex-col">
        <div className="px-4 sm:px-10 lg:px-20 flex flex-1 justify-center py-5">
          <div className="layout-content-container flex flex-col max-w-[1200px] flex-1">
            <NewsFeed 
              news={news} 
              memberData={memberData}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagerDashboard;
